import { SourceOption } from "@/features/annotation/lib/types";

export const FRAME_DURATION = 30;
export const TRACK_SNAPSHOT_MAXIMUM_GAP_THRESHOLD = 1000;

export const lineConfig: [number, number][] = [
  [15, 13],
  [13, 11],
  [16, 14],
  [14, 12],
  [11, 12],
  [5, 11],
  [6, 12],
  [5, 6],
  [5, 7],
  [6, 8],
  [7, 9],
  [8, 10],
  [1, 2],
  [0, 1],
  [0, 2],
  [1, 3],
  [2, 4],
  [3, 5],
  [4, 6],
];

export const pointNames = [
  "nose",
  "l_eye",
  "r_eye",
  "l_ear",
  "r_ear",
  "l_shoulder",
  "r_shoulder",
  "l_elbow",
  "r_elbow",
  "l_wrist",
  "r_wrist",
  "l_hip",
  "r_hip",
  "l_knee",
  "r_knee",
  "l_ankle",
  "r_ankle",
];

export const VIDEO_START_TIME_KEY = "From-Date-Time";

export const VIEW_TYPES = {
  GONDOLA_CAMERA_VIEW: "gondola-view",
  VIEW_3D: "3d-view",
} as const;

export const CAMERA_FRAME_IMAGE_SIZE = {
  width: 1920,
  height: 1080,
};

export const GATEWAY_USER_ROLES = {
  POS: "POS",
  DATA_COLLECTION_SUPER: "DATA_COLLECTION_SUPER",
  SUPERUSER: "SUPERUSER",
  PRE_ORDER_DASHBOARD: "PRE_ORDER_DASHBOARD",
} as const;

export const CAMERA_TYPES = {
  HAND_TRACKING: "hand_tracking",
  SHELF_TRACKING: "shelf_tracking",
} as const;

export const STORE_KEYS = {
  GOKTURK: "store-gokturk",
  GOKTURK_POD: "store-gokturk-pod",
  ST2: "st-2",
  ST1: "st-1",
  STAGING: "staging",
} as const;

export const STORE_DEFAULT_CAMERAS_CONFIG = {
  [STORE_KEYS.GOKTURK]: [
    "11",
    "15",
    "53",
    "100",
    "105",
    "109",
    "115",
    "116",
    "119",
    "136",
    "143",
  ],
  [STORE_KEYS.GOKTURK_POD]: ["148", "151", "161", "162", "163"],
  [STORE_KEYS.ST2]: ["2", "4", "32", "33", "34"],
  [STORE_KEYS.ST1]: [
    "101",
    "108",
    "136",
    "147",
    "148",
    "232",
    "240",
    "329",
    "330",
    "331",
  ],
  [STORE_KEYS.STAGING]: ["2", "4", "32", "33", "34"],
  default: [
    "11",
    "15",
    "53",
    "100",
    "105",
    "109",
    "115",
    "116",
    "119",
    "136",
    "143",
  ],
};

export const SOURCE_OPTIONS: SourceOption[] = [
  { key: "sku-in-box", value: "sku-in-box" },
  { key: "mobile-app-hitl", value: "mobile-app-hitl" },
  { key: "coffee_machine", value: "coffee_machine" },
  { key: "temporary-order", value: "temporary-order" },
  { key: "tracker-test-setup", value: "tracker-test-setup" },
  {
    key: "anonymous-journey-recordings",
    value: "anonymous-journey-recordings",
  },
  { key: "journey-recordings", value: "journey-recordings" },
];
